var map = {
	"./academicAffairs.ts": "f2b7",
	"./accountInfo.ts": "0b69",
	"./attenceAnalysis.ts": "acfd",
	"./authorityManagement.ts": "4b26",
	"./classAdministration.ts": "c8a7",
	"./computer.ts": "0d61",
	"./dataAnalysis.ts": "acd6",
	"./educNotification.ts": "ea24",
	"./home.ts": "aff8",
	"./inspectopen.ts": "949e",
	"./liveClassroom.ts": "c56f",
	"./login.ts": "179a",
	"./migration.ts": "071f",
	"./mooc.ts": "9c93",
	"./onlineData.ts": "88f1",
	"./pageDesign.ts": "12da",
	"./panelDataScreen.ts": "eb57",
	"./portal.ts": "e32f",
	"./recordedBroadcastClassroom.ts": "f0f9",
	"./resourceLibrary.ts": "e942",
	"./storagefee.ts": "f36e",
	"./studentEvaluation.ts": "b0b3",
	"./systemJournal.ts": "9d29",
	"./teachingResearch.ts": "b1ad",
	"./valueAddedServices.ts": "8cda",
	"./vipManagement.ts": "e548"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e505";